<template>
  <section>
    <div class="table-responsive">
      <table class="table w-full table-data min-w-table overflow-hidden">
        <thead>
          <tr>
            <th class="w-12" />
            <th v-text="'Submitter'" />
            <th v-text="'Submitted'" />
            <th v-text="'View Submission'" />
          </tr>
        </thead>
        <tbody v-if="submissions.length">
          <tr
            is="Row"
            v-for="submission in submissions"
            :key="submission.id"
            :submission="submission"
          />
        </tbody>
        <tbody v-else>
          <tr>
            <td
              colspan="5"
              class="text-center"
              v-text="'No results'"
            />
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script type="text/babel">
import { mapState } from 'vuex'
import Row from './FormSubmissionRow'

export default {
  name: 'FormSubmissionList',
  components: {
    Row,
  },
  computed: {
    ...mapState({
      count: state => state.form.submissions.data.length,
      totalCount: state => _.get(state.form.submissions, 'meta.pagination.total', 0),
      submissions: state => state.form.submissions.data,
    }),
  },
}
</script>
